import { Grid, Cell } from 'baseui/layout-grid';
import { Input } from 'baseui/input';
import { SIZE, Select } from 'baseui/select';
import capitalize from 'lodash/capitalize';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import startsWith from 'lodash/startsWith';
import { styled } from 'baseui';
import DeleteAlt from 'baseui/icon/delete-alt';
import React, { PureComponent } from 'react';
import { type ConditionType, type QnAStateType, operators } from '../../reducers';
import { EditModeInput } from '../common/Input';
import { arrayToSelectOptions, stringToSelectOption } from '../../utils/select';
import { getQuestionById, possibleQuestionForFollowUpConditionSelector } from '../../reducers/selectors';
const ConditionItem = styled('div', {
  display: 'block',
  margin: 0
});
type Props = {
  condition: ConditionType;
  targetQuestionId: string;
  state: QnAStateType;
  onChange: Function;
  onDelete: Function;
  editMode: boolean;
};
export default class Condition extends PureComponent<Props> {
  UNSAFE_componentWillReceiveProps(nextProps: Props) {
    // remove condition when source question is deleted
    const {
      condition,
      state,
      onDelete
    } = nextProps;
    const sourceQuestionId = get(condition, 'id');
    const question = getQuestionById(state, sourceQuestionId);
    if (isEmpty(question)) {
      onDelete();
    }
  }
  render() {
    const {
      editMode,
      condition,
      targetQuestionId,
      state,
      onChange,
      onDelete
    } = this.props;
    if (isEmpty(condition)) return null;
    const sourceQuestionId = get(condition, 'id');
    const sourceQuestionAnswer = get(condition, 'answer');
    const question = getQuestionById(state, sourceQuestionId);
    if (isEmpty(question)) return null;
    const questionName = get(question, 'question');
    const questionAnswerItems = get(question, 'answers');
    const operator = get(condition, 'operator') || 'equals';
    const isMetadataOperator = startsWith(operator, 'metadata_');
    return <ConditionItem>
        <Grid gridGaps={[3, 0, 0]} gridGutters={[3]} gridMargins={[0]}>
          <Cell span={[4, 4, 6]}>
            <EditModeInput value={questionName} editMode={editMode}>
              <Select valueKey={'value'} placeholder={'Select question'} size={SIZE.compact} value={sourceQuestionId ? [{
              value: sourceQuestionId,
              label: questionName
            }] : []} onChange={option => {
              const id = get(option, 'option.value');
              const question = getQuestionById(state, id);
              const {
                answer = ''
              } = get(question, 'answers')[0] || {};
              onChange({
                ...condition,
                id,
                answer
              });
            }} clearable={false} options={possibleQuestionForFollowUpConditionSelector(state, targetQuestionId)} />
            </EditModeInput>
          </Cell>
          <Cell span={[4, 2, 2]}>
            <EditModeInput value={operator} editMode={editMode}>
              <Select valueKey={'id'} labelKey={'id'} placeholder={'Select operator'} size={SIZE.compact} value={stringToSelectOption({
              value: operator
            })} onChange={option => {
              const operator = get(option, 'option.id');
              onChange({
                ...condition,
                operator
              });
            }} options={arrayToSelectOptions({
              values: operators
            })} />
            </EditModeInput>
          </Cell>
          <Cell span={[4, 2, 4]}>
            <Grid gridGaps={[0]} gridGutters={[0]} gridMargins={[0]}>
              <Cell span={[3, 6, 10]}>
                <EditModeInput value={sourceQuestionAnswer} editMode={editMode}>
                  {isMetadataOperator ? <Input size={SIZE.compact} type="text" placeholder="e.g. path1.path2==value" value={sourceQuestionAnswer} onChange={e => {
                  onChange({
                    ...condition,
                    answer: e.target.value
                  });
                }} /> : <Select creatable valueKey={'value'} placeholder={'Select answer'} size={SIZE.compact} value={sourceQuestionAnswer ? [{
                  value: sourceQuestionAnswer,
                  label: sourceQuestionAnswer
                }] : []} onChange={option => {
                  onChange({
                    ...condition,
                    answer: get(option, 'option.value')
                  });
                }} options={questionAnswerItems.map(answerItem => ({
                  label: capitalize(answerItem.answer),
                  value: answerItem.answer
                }))} />}
                </EditModeInput>
              </Cell>
              <Cell span={[1, 2, 2]}>
                {editMode && <DeleteAlt size="25px" style={{
                verticalAlign: 'middle'
              }} onClick={() => {
                onDelete();
              }} />}
              </Cell>
            </Grid>
          </Cell>
        </Grid>
      </ConditionItem>;
  }
}